"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaxonomyClassesContainer = void 0;
const react_1 = __importStar(require("react"));
const predicate_language_1 = require("@groupby/predicate-language");
const ramda_1 = require("ramda");
const react_redux_1 = require("react-redux");
const taxonomy_classes_sidebar_section_component_1 = require("./taxonomy-classes-sidebar-section.component");
const constants_1 = require("../../../../constants");
const hooks_1 = require("../../../../hooks");
const localization_1 = require("../../../../localization");
const hooks_2 = require("../../../hooks");
const store_1 = require("../../../../store");
const utils_1 = require("../../../../utils");
const TaxonomyClassesContainer = ({ debouncedSearchTerm, classTotals, }) => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const taxonomyClasses = (0, store_1.useClassesSelector)();
    const [currentOrganizationsIds] = (0, store_1.useSelectedOrganizationsIdsSelector)();
    const client = (0, hooks_1.useEnrichClient)();
    const { addError } = (0, hooks_1.useNotification)();
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const token = (0, hooks_1.useToken)();
    const isLoading = (0, store_1.useClassesIsLoadingSelector)();
    const refinementsData = (0, store_1.useRefinementsDataSelector)();
    const refinementsLoading = (0, store_1.useRefinementsLoadingSelector)();
    const { getV2Ids } = (0, hooks_2.useNodesTree)();
    const getTaxonomyClasses = () => {
        var _a;
        if (currentOrganizationsIds && ((_a = refinementsData === null || refinementsData === void 0 ? void 0 : refinementsData.classIds) === null || _a === void 0 ? void 0 : _a.length)) {
            const classes = refinementsData.classIds.reduce((acc, id) => {
                const taxonomyClass = taxonomyClasses.byId[id];
                if (!id || !taxonomyClasses.allIds.length || !(taxonomyClass === null || taxonomyClass === void 0 ? void 0 : taxonomyClass.title.toLowerCase().includes(debouncedSearchTerm.toLowerCase())))
                    return acc;
                return [...acc, Object.assign(Object.assign({}, taxonomyClass), { total: classTotals[taxonomyClass === null || taxonomyClass === void 0 ? void 0 : taxonomyClass.id] })];
            }, []);
            dispatch((0, store_1.taxonomyClassesSetInUseTerminalNodes)(classes));
        }
        else {
            dispatch((0, store_1.taxonomyClassesSetInUseTerminalNodes)([]));
        }
    };
    (0, react_1.useEffect)(() => {
        void getTaxonomyClasses();
    }, [debouncedSearchTerm, classTotals, refinementsData.classIds, currentOrganizationsIds, taxonomyClasses.byId, taxonomyClasses.allIds]);
    const fetchRequestTaxonomyClasses = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            dispatch((0, store_1.taxonomyClassesSetIsLoading)(true));
            const filter = (0, predicate_language_1.where)((0, predicate_language_1.uuid)(constants_1.TAXONOMY_CLASS_V2_ID), '@<', (0, predicate_language_1.f) `hierarchy`);
            const [resultClasses, resultTaxonomyNodes] = yield Promise.all([(0, utils_1.getAllData)(client.classes), (0, utils_1.getAllData)(client.taxonomyNodes, filter)]);
            const classes = (0, utils_1.normalize)((0, ramda_1.flatten)(resultClasses));
            const [v2Ids, v2TerminalIds] = getV2Ids(resultTaxonomyNodes, classes.byId);
            const taxonomyClasses = Object.assign(Object.assign({}, classes), { v2TerminalIds,
                v2Ids });
            dispatch((0, store_1.taxonomyClassesSetData)(taxonomyClasses));
        }
        catch (_a) {
            addError(t({ key: 'TAXONOMY_CLASSES_LOADING_ERROR' }));
        }
        finally {
            dispatch((0, store_1.taxonomyClassesSetIsLoading)(false));
        }
    });
    (0, react_1.useEffect)(() => {
        if (token) {
            void fetchRequestTaxonomyClasses();
        }
    }, [token]);
    return (react_1.default.createElement(taxonomy_classes_sidebar_section_component_1.TaxonomyClassesSideBarSection, { isLoading: refinementsLoading || isLoading, debouncedSearchTerm: debouncedSearchTerm }));
};
exports.TaxonomyClassesContainer = TaxonomyClassesContainer;
exports.default = react_1.default.memo(exports.TaxonomyClassesContainer);
